import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TableRow } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { CalibrationId } from 'services/equipmentSets/types';

import { selectIsWeedSprayWorksheet } from '../../../../../../selectors';
import ApplicationRateTableCell from './components/ApplicationRateTableCell';
import MinRowWidthTableCell from './components/MinRowWidthTableCell';
import MaxRowWidthTableCell from './components/MaxRowWidthTableCell';
import SwathWidthTableCell from './components/SwathWidthTableCell';
import GearTableCell from './components/GearTableCell';
import SpeedTableCell from './components/SpeedTableCell';
import PressureTableCell from './components/PressureTableCell';
import EngineRpmTableCell from './components/EngineRpmTableCell';
import FanSpeedTableCell from './components/FanSpeedTableCell';
import NozzlesPerSideTableCell from './components/NozzlesPerSideTableCell';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    isWeedSpray: ReturnType<typeof selectIsWeedSprayWorksheet>;
}

type Props = OwnProps & ConnectedProps;

export class PrintSprayWorksheetCalibrationTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { calibrationId, pageIndex, isWeedSpray } = this.props;

        return (
            <TableRow>
                <ApplicationRateTableCell
                    calibrationId={calibrationId}
                    pageIndex={pageIndex}
                />
                <MinRowWidthTableCell
                    calibrationId={calibrationId}
                    pageIndex={pageIndex}
                />
                <MaxRowWidthTableCell
                    calibrationId={calibrationId}
                    pageIndex={pageIndex}
                />
                {isWeedSpray ? (
                    <SwathWidthTableCell
                        calibrationId={calibrationId}
                        pageIndex={pageIndex}
                    />
                ) : null}
                <GearTableCell
                    calibrationId={calibrationId}
                    pageIndex={pageIndex}
                />
                <SpeedTableCell
                    calibrationId={calibrationId}
                    pageIndex={pageIndex}
                />
                <PressureTableCell
                    calibrationId={calibrationId}
                    pageIndex={pageIndex}
                />
                <EngineRpmTableCell
                    calibrationId={calibrationId}
                    pageIndex={pageIndex}
                />
                {isWeedSpray ? (
                    <NozzlesPerSideTableCell
                        calibrationId={calibrationId}
                        pageIndex={pageIndex}
                    />
                ) : (
                    <FanSpeedTableCell
                        calibrationId={calibrationId}
                        pageIndex={pageIndex}
                    />
                )}
            </TableRow>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isWeedSpray: selectIsWeedSprayWorksheet
});

export default connect(mapStateToProps)(PrintSprayWorksheetCalibrationTableRow);
